<template>
    <div>
        <template v-if="data !== false && data !== null">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="mt-0"> Leave Status </h1>
                </div>
                <div class="global-main leaves-edit-holder">
                    <div class="leave-edit-box">
                        <div class="row">
                            <div class="col-6 pr-0 border-rt">
                                <div class="div-row">
                                    <div class="leave-item p-2">Leave Applied By</div>
                                    <div class="leave-item p-2">{{application.applicant_name | capitalize}}</div>
                                </div>
                                <!-- <div class="div-row">
                                    <div class="leave-item p-2">Line Manager</div>
                                    <div class="leave-item p-2">{{line_manager.name}}</div>
                                </div> -->
                                <div class="div-row">
                                    <div class="leave-item p-2">Leave Type</div>
                                    <div class="leave-item p-2">{{application.leave_type | capitalize}}</div>
                                </div>
                                <div class="div-row" v-if="application.partial_leave">
                                    <div class="leave-item p-2">Partial Leave</div>
                                    <div class="leave-item p-2">{{application.partial_leave | capitalize}}</div>
                                </div>
                                <div class="div-row">
                                    <div class="leave-item p-2">Reason</div>
                                    <div class="leave-item p-2">{{application.description | capitalize}}</div>
                                </div>
                            </div>
                            <div class="col-6 pl-0">
                                <div class="div-row">
                                    <div class="leave-item p-2">Backup / Point Of Contact</div>
                                    <div class="leave-item p-2">{{application.alternative_backup_name | capitalize}}</div>
                                </div>
                                <div class="div-row">
                                    <div class="leave-item p-2">Status</div>
                                    <div class="leave-item p-2">{{application.leave_status | capitalize}}</div>
                                </div>
                                <div class="div-row" v-if="application.partial_leave">
                                   <div class="leave-item p-2">Leave Duration</div>
                                    <div class="leave-item p-2">{{application.partial_leave_duration | capitalize}} Hour</div>
                                </div>
                                <div class="div-row" v-else>
                                    <div class="leave-item p-2">Leave Days</div>
                                    <div class="leave-item p-2">{{application.total_days | capitalize}}</div>
                                </div>
                                <div class="div-row">
                                    <div class="leave-item p-2">Date From</div>
                                    <div class="leave-item p-2">{{application.leave_start | date_format}}</div>
                                </div>
                                <div class="div-row">
                                    <div class="leave-item p-2">Date To</div>
                                    <div class="leave-item p-2">{{application.leave_end | date_format}}</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div v-if="applicationMessage.length > 0">
                        <h2 class="m-3">Message History</h2>
                        <div class="leave-edit-box">
                            <div class="row" v-for="am in applicationMessage" :key="am.id">
                                <div class="col-6 pr-0 border-rt">
                                    <div class="div-row">
                                        <div class="leave-item p-2">Message By</div>
                                        <div class="leave-item p-2">{{am.message_sender_name.name | capitalize}}</div>
                                    </div>
                                    <div class="div-row">
                                        <div class="leave-item p-2">Date</div>
                                        <div class="leave-item p-2">{{am.created_at | date_format}}</div>
                                    </div>
                                    <div class="div-row">
                                        <div class="leave-item p-2">Action</div>
                                        <div class="leave-item p-2" v-if="am.approval_status == 'REQUEST_AGAIN'">Request Again</div>
                                        <div class="leave-item p-2" v-else-if="am.approval_status == 'APPROVED'">Approved</div>
                                        <div class="leave-item p-2" v-else-if="am.approval_status == 'REJECT'">Reject</div>
                                    </div>
                                </div>
                                <div class="col-6 pl-0">
                                    <div class="message-box p-2">
                                        Message
                                        <p class="mt-2 ml-2">{{am.message}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-holder mt-4" v-if="can_update">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Status<em class="required">*</em> </label>
                                    <select name="approval_status" class="form-control selectpicker custom-select2" v-model="form.approval_status" :class="{ 'is-invalid': form.errors.has('approval_status') }">
                                        <option value="">Select Status</option>
                                        <option value="APPROVED">Approve</option>
                                        <option value="REJECT">Reject</option>
                                    </select>
                                    <has-error :form="form" field="approval_status"></has-error>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Message<em class="required">*</em> </label>
                                    <textarea class="form-control" name="message" id="message" v-model="form.message" :class="{ 'is-invalid': form.errors.has('message') }"></textarea>
                                    <has-error :form="form" field="message"></has-error>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group text-right">
                                    <input type="submit" :disabled="form.busy" class="btn btn-primary" @click="submitMessage()" value="Submit" name="Save">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="data === null">
            <preLoader/>
        </template>
        <template v-else-if="data === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data:null,
            application:null,
            applicationMessage:[],
            // line_manager:[],
            form: new Form({
                leaveId : this.$route.params.id,
                approval_status: null,
                message: null,

            }),
            can_update: null,
            company_status: null,
        };
    },
    mounted() {
        this.$global.getName();
        this.$Progress.start();
        axios.get('/api/viewLeaveApplication/'+this.$route.params.id)
            .then(res => {
                this.data = res.data;
                if(this.data){
                    this.application = res.data.application;
                    this.applicationMessage = res.data.applicationMessage;
                    // this.line_manager = res.data.line_manager;
                    this.can_update = res.data.flag;
                    this.company_status = res.data.company_status;
                }

                this.$Progress.finish();
            }).then(res => {
                $('.selectpicker').selectpicker();
            }).catch(err => {
                console.log(err);
            });
    },

    methods: {
        submitMessage(){
            this.$Progress.start();
                this.form.post('/api/addLeaveApplicationMessage')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Leave status updated successfully');
                        this.$router.push('/employeeLeaves');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }

                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
        }
    },
}

</script>
